import { aos } from './modules/aos';
import { modal } from './modules/modal';
import { pageTop } from './modules/pageTop';
import { scrollHint } from './modules/scrollHint';
import { smooth } from './modules/smooth';

aos();
modal();
pageTop();
smooth();
scrollHint();
